export class DataCasesSet{
  user_id: number;
  status_id: string;
  category_id: string;
  expedient:string;
  title:string;
  synopsis:string;

}
